import type { ComponentType } from 'react';

import styled from 'styled-components';

import type { SWReactIconProps } from '@similarweb/icons';
import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import type { TableEmptyStateView } from './TableEmptyState';

export const StyledTableEmptyContainer = styled.div<{ view: TableEmptyStateView }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ view }) => (view === 'noResults' ? '108px 16px 92px' : '120px 16px 72px')};
`;

export const StyledTableEmptyTitle = styled.div`
  ${setFontVariant('subtitle1', colorsPalettes.carbon[500])};
  text-align: center;
  margin-top: 14px;
`;

export const StyledTableEmptySubtitle = styled.div`
  ${setFontVariant('caption', colorsPalettes.carbon[300])};
  font-size: 12px;
  text-align: center;
`;

export const StyledTableEmptyIcon = styled<ComponentType<SWReactIconProps & { view: TableEmptyStateView }>>(
  SWReactIcons
)`
  svg {
    width: ${({ view }) => (view === 'noResults' ? '125px' : '175px')};
    margin: ${({ view }) => (view === 'noResults' ? '0 0 0 4px' : '0 0 3px 4px')};
  }
`;
